import { navigate } from 'gatsby';
import { urlConfig } from '@/config/link';
import paths from './paths.json';
import { IMenuData, INavigationItemList } from './models/navigationModel';
import { NEWLINE, RRP_ACCESSORY } from '@/config/common';
import { orderTypeConfig } from '@/config/orderTypeLink';

export const headerMenuUrlMapping = (headerMenu: INavigationItemList[]) => {
  return headerMenu?.map((item: INavigationItemList) => ({
    ...item,
    ...urlConfig[item.link],
    pathname: urlConfig[item.link]?.pathname || '#',
    ...(item.navigationItemList && {
      navigationItemList: headerMenuUrlMapping(item.navigationItemList)
    })
  }));
};

export const getPath = (key: string) => paths[key];

export const getPathUrls = () =>
  Object.keys(paths).reduce((keyMap: object, path: string) => {
    keyMap[path] = paths[path].url;
    return keyMap;
  }, {});

export const getPathKeys = () =>
  Object.keys(paths).reduce((keyMap: object, path: string) => {
    keyMap[path] = path;
    return keyMap;
  }, {});

export const hasAuth = (key: string) => {
  const path = getPath(key);
  return path.auth;
};

export const getPermissions = (key: string) => {
  const path = getPath(key);
  return path.permission;
};

export const getPathURL = (key: string) => {
  const path = getPath(key);
  return path?.url;
};

export const navigateTo = (key: string, queryParams = {}) => {
  const url = getPathURL(key) || key;
  const queryString = Object.keys(queryParams).reduce((qs, paramKey) => {
    if (!qs) qs = '?';
    qs = `${qs}&${paramKey}=${queryParams[paramKey]}`;
    return qs;
  }, '');
  navigate(`${url}${queryString}`);
};

export const formatterPath: Function = (data: [], parentPath = '/') => {
  return data.map((item: { path; children }) => {
    let path = parentPath + item.path;

    const result = {
      ...item,
      path
    };

    if (item.children) {
      result.children = formatterPath(item.children, `${parentPath}${item.path}/`);
    }
    return result;
  });
};

export const removeLastSlash = (site: string) => {
  return site.replace(/\/$/, '');
};

export const getPageData = (menuData: IMenuData[], pathname = '') => {
  for (let value of menuData) {
    const result = value.children.find(
      (item: { path: string }) => removeLastSlash(item.path) === removeLastSlash(pathname)
    );

    if (result) {
      return result;
    }
  }

  return false;
};

export const getAllFlowsPath = () => {
  const flowUrls: string[] = []
  Object.keys(orderTypeConfig).forEach((flow) => {
    flowUrls.push(orderTypeConfig[flow].pathname)
  })
  return flowUrls
}

export const getOrderTypeByPath = (path = '/order/priceplan') => {
  if (path === '/order/equipment?rrpType=accessory') return RRP_ACCESSORY;
  return Object.values(orderTypeConfig).filter(flow =>
    flow.pathname === path
  )[0].ordertype
}

export const getPathByOrderType = (orderType = NEWLINE) => {
  if (orderType === RRP_ACCESSORY) return '/order/equipment';
  return orderTypeConfig[orderType].pathname;
}

export default navigateTo;
